module.exports = __webpack_public_path__ + "img/index_card_selfJa.53db8212.svg";